export enum EnrollmentByStageEnum {
  minimumEnrollmentPre = 16,
  minimumEnrollmentEFAI = 40,
  minimumEnrollmentEFAF = 32,
  minimumEnrollmentEM = 24,
  minimumEnrollmentEJA = 16
}
